import React from "react";
import { Box, Typography } from "@mui/material";
import Button from "./elements/Button";
import Modal from 'react-modal';

Modal.setAppElement('#root');

export const CreateActivityPopup = ({ open, onClose }) => {

    return (
        <Box>
            <Modal
                isOpen={open}
                onRequestClose={onClose}
                className="Modal"
                contentLabel="Create Activity Modal"
            >
                <Box
                    className="max-w-[525px] bg-white mx-auto rounded-lg relative overflow-hidden py-8 px-10 sm:px-12 md:px-[60px] mt-24"
                    style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}
                >
                    <button
                        onClick={onClose}
                        className="absolute top-2 md:right-2 sm-right-3 text-red-500 hover:text-red-700"
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-6 w-6"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M6 18L18 6M6 6l12 12"
                            />
                        </svg>
                    </button>
                    <form style={{ width: "100%" }}>
                        <Box className="mt-4 mb-4">
                            <label htmlFor="activity">Activity
                                <input
                                    type="text"
                                    placeholder="e.g Times Square"
                                    className="
                                        w-full
                                        rounded-md
                                        border
                                        border-[#E9EDF4]
                                        py-3
                                        px-5
                                        bg-[#FCFDFE]
                                        text-black
                                        placeholder-[#ACB6BE]
                                        outline-none
                                        focus-visible:shadow-none
                                        focus:border-pry
                                    "
                                />
                            </label>
                        </Box>
                        <Box className="mt-4 mb-4">
                            <label htmlFor="starttime">Start Time
                                <input
                                    type="text"
                                    placeholder="Add start time"
                                    className="
                                        w-full
                                        rounded-md
                                        border
                                        border-[#E9EDF4]
                                        py-3
                                        px-5
                                        bg-[#FCFDFE]
                                        text-black
                                        placeholder-[#ACB6BE]
                                        outline-none
                                        focus-visible:shadow-none
                                        focus:border-pry
                                    "
                                />
                            </label>
                        </Box>
                        <Box className="mb-3">
                            <label htmlFor="location">Estimated Cost
                                <input
                                    type="text"
                                    placeholder="Estimated Cost"
                                    className="
                                        w-full
                                        rounded-md
                                        border
                                        border-[#E9EDF4]
                                        py-3
                                        px-5
                                        bg-[#FCFDFE]
                                        text-black
                                        placeholder-[#ACB6BE]
                                        outline-none
                                        focus-visible:shadow-none
                                        focus:border-pry
                                    "
                                />
                            </label>
                        </Box>
                        <Box className="mt-[-6%] mb-5">
                            <Button size="large" className="px-12">Save</Button>
                            <Typography
                                variant="h6"
                                paragraph
                                sx={{
                                    fontWeight: "400",
                                    textAlign: "center",
                                    marginTop: "10px",
                                    marginBottom: "50px",
                                    fontSize: "14px"
                                }}
                                className="text-gray-500"
                            >
                                Cancel
                            </Typography>
                        </Box>
                    </form>
                </Box>
            </Modal>
        </Box>
    );
};
